class FileError extends Error {
  fileName: string
  lineNumber: number
  buffer: string

  constructor(message: string, fileName: string = '', lineNumber: number = 0, buffer: string = '') {
    super(message)
    this.name = 'FileError'
    this.fileName = fileName
    this.lineNumber = lineNumber
    this.buffer = buffer

    Object.setPrototypeOf(this, new.target.prototype)
  }

  getFormattedMessage(): string {
    return `${this.name}: ${this.message}\nFile: ${this.fileName}\nLine: ${this.lineNumber}\nBuffer: ${this.buffer}`
  }

  getErrorObject(): Record<string, any> {
    return {
      name: this.name,
      message: this.message,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      buffer: this.buffer,
      stack: this.stack
    }
  }
}

export default FileError
